"use client";

import { FC } from "react";
import { useTranslations } from "next-intl";

import { ExtendedJobRecord } from "@types";
import { SLUGS } from "consts";

import { ImageTeaser } from "./templates/ImageTeaser";

interface Props {
  job: ExtendedJobRecord;
}

export const JobTeaser: FC<Props> = ({ job }) => {
  const t = useTranslations("common");

  return (
    <ImageTeaser
      title={job.title}
      link={{ href: SLUGS.jobs, slug: job.id }}
      urlImage={job.image}
      address={job.city}
      description={job.shortIntro}
      buttonLabel={t("more-details")}
    />
  );
};
